export default __webpack_public_path__ + "static/media/Hair_1_M_C5.1a2f79d5.svg";